<div class="main container-fluid">
  <div class="page-header">

    <div class="title">
      Dashboard
    </div>

  </div>

  <div class="page-filter">
    <div class="date-filter shadow-sm">
      <!-- <span><i class="fa fa-calendar pr-2"></i>custom</span> -->
      <span *ngFor=" let item of customDates; index as i;" data-toggle="title"
      [title]="'From '+ item.ldate +' to '+ item.gdate"
        (click)="setDateRange(item.ldate, item.gdate)">{{item.label}}</span>
      <!-- <span>lifetime</span> -->

    </div>
  </div>

  <div class="page-body">
    <div class="row">
      <div class="col-12 col-lg-9">
        <div class="card shadow-sm">
          <div class="card-title">
            <div class="title">Orders Perfomance</div>
            <div class="subtitle">Total value of orders made</div>
          </div>
          <div class="card-body position-relative">
            <div class="row">
              <div class="col-auto">
                <div class="stat-box">
                  <h3>{{totalAmountFarmer | currency:"UGX ":"symbol":"1.0-0"}}</h3>
                  <div class="stat-label">
                    <span class="indicator bg-farmer"></span> Farmers
                  </div>
                </div>
              </div>

              <div class="col-auto border-left">
                <div class="stat-box">
                  <h3>{{totalAmountMA | currency: "UGX ":"symbol":"1.0-0"}}</h3>
                  <div class="stat-label">
                    <span class="indicator bg-ma"></span> Merchants
                  </div>
                </div>
              </div>
            </div>

            <div style="display: block;" class="chart">
            
              <canvas height="110" baseChart [datasets]="orderDatasets" [labels]="orderChartLabels"
                [options]="orderChartOptions" [chartType]="'line'">
              </canvas>
            </div>
<div class="full-loader" *ngIf="loaderTotals">
  <div class="spinner-border text-secondary spinner-lg" ></div>
</div>
          
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3">

        <div class="card mb-3">
          <div class="card-title border-bottom">
            <div class="title">
              Unique Customers 
            </div>
            <div class="subtitle">unique customers who ordered in this period
              including cancelled orders</div>
          </div>

          <div class="card-body position-relative">
            <div class="row">
              <div class="col">
                <div class="stat-box text-center">
                  <h1 class="color-farmer fw-bold">
                    {{uniqueFarmers}}
                  </h1>
                  <div class="stat-label">
                    Farmers
                  </div>
                </div>
              </div>

              <div class="col border-left">
                <div class="stat-box text-center">
                  <h1 class="color-ma fw-bold">
                    {{uniqueMA}}
                  </h1>
                  <div class="stat-label">
                    Merchants
                  </div>
                </div>
              </div>
            </div>

            <div class="full-loader" *ngIf="loaderUnique">
              <div class="spinner-border text-secondary spinner-lg" ></div>
            </div>
                   
          </div>

        </div>

        <div class="card">
          <div class="card-title border-bottom">
            <div class="title">
              Most Purchased
            </div>

          </div>

          <div class="card-body position-relative">
            <ul class="simple-list">
              <li *ngFor="let item of mostOrdered; index as i;">
                <div class="row">
                  <div class="col">
                    <div class="title">{{item.product}}</div>
                    <div class="subtitle">{{item.supplier}}</div>
                  </div>
                  <div class="col-auto">
                    <div class="fw-bold">{{item.NoTimes}} </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="full-loader" *ngIf="loaderMostPurchased">
              <div class="spinner-border text-secondary spinner-lg" ></div>
            </div>
                   
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
